import { toast } from "react-toastify";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Input, InputProps } from "reactstrap";

import i18n from "../../i18n";
import { SelectListDto } from "../../models";
import { CategoryTypeEnum } from "../../enums";
import { useGetCategorySelectListQuery } from "../../store/api/categoryApi";

type TProps = InputProps & {
  placeholder: string;
  categoryType: CategoryTypeEnum;
};

export const CategorySelect: React.FC<TProps> = (props) => {
  const { t } = useTranslation();

  const { data, error, isLoading } = useGetCategorySelectListQuery(
    props.categoryType,
  );

  useEffect(() => {
    if (error) {
      const errMsg =
        "status" in error
          ? (error.data as any)?.message || "An error occurred"
          : "An error occurred";
      toast.error(errMsg, {
        autoClose: 3000,
      });
    }
  }, [error]);

  return (
    <div className="input-group">
      <Input {...props}>
        <option value={""}>{t(props.placeholder)} </option>
        {data &&
          data.length &&
          data.map(({ id, value }: SelectListDto) => (
            <option value={id} key={id} className="text-capitalize">
              {i18n.language === "ar" ? value.ar : value.en}
            </option>
          ))}
      </Input>
    </div>
  );
};
